/* tslint:disable */
/* eslint-disable */
/**
 * GLC.ClientPortal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { GHUBPARTYTYPE } from './GHUBPARTYTYPE';
import {
    GHUBPARTYTYPEFromJSON,
    GHUBPARTYTYPEFromJSONTyped,
    GHUBPARTYTYPEToJSON,
} from './GHUBPARTYTYPE';
import type { LegalEntityDetails } from './LegalEntityDetails';
import {
    LegalEntityDetailsFromJSON,
    LegalEntityDetailsFromJSONTyped,
    LegalEntityDetailsToJSON,
} from './LegalEntityDetails';
import type { NaturalPersonDetails } from './NaturalPersonDetails';
import {
    NaturalPersonDetailsFromJSON,
    NaturalPersonDetailsFromJSONTyped,
    NaturalPersonDetailsToJSON,
} from './NaturalPersonDetails';

/**
 * 
 * @export
 * @interface ClientPersonalDetailsViewModel
 */
export interface ClientPersonalDetailsViewModel {
    /**
     * 
     * @type {NaturalPersonDetails}
     * @memberof ClientPersonalDetailsViewModel
     */
    naturalPersonDetails?: NaturalPersonDetails;
    /**
     * 
     * @type {LegalEntityDetails}
     * @memberof ClientPersonalDetailsViewModel
     */
    legalEntityDetails?: LegalEntityDetails;
    /**
     * 
     * @type {GHUBPARTYTYPE}
     * @memberof ClientPersonalDetailsViewModel
     */
    clientType: GHUBPARTYTYPE;
    /**
     * 
     * @type {string}
     * @memberof ClientPersonalDetailsViewModel
     */
    clientId: string;
    /**
     * 
     * @type {boolean}
     * @memberof ClientPersonalDetailsViewModel
     */
    isIssuedClient: boolean;
}

/**
 * Check if a given object implements the ClientPersonalDetailsViewModel interface.
 */
export function instanceOfClientPersonalDetailsViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "clientType" in value;
    isInstance = isInstance && "clientId" in value;
    isInstance = isInstance && "isIssuedClient" in value;

    return isInstance;
}

export function ClientPersonalDetailsViewModelFromJSON(json: any): ClientPersonalDetailsViewModel {
    return ClientPersonalDetailsViewModelFromJSONTyped(json, false);
}

export function ClientPersonalDetailsViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClientPersonalDetailsViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'naturalPersonDetails': !exists(json, 'NaturalPersonDetails') ? undefined : NaturalPersonDetailsFromJSON(json['NaturalPersonDetails']),
        'legalEntityDetails': !exists(json, 'LegalEntityDetails') ? undefined : LegalEntityDetailsFromJSON(json['LegalEntityDetails']),
        'clientType': GHUBPARTYTYPEFromJSON(json['ClientType']),
        'clientId': json['ClientId'],
        'isIssuedClient': json['IsIssuedClient'],
    };
}

export function ClientPersonalDetailsViewModelToJSON(value?: ClientPersonalDetailsViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'NaturalPersonDetails': NaturalPersonDetailsToJSON(value.naturalPersonDetails),
        'LegalEntityDetails': LegalEntityDetailsToJSON(value.legalEntityDetails),
        'ClientType': GHUBPARTYTYPEToJSON(value.clientType),
        'ClientId': value.clientId,
        'IsIssuedClient': value.isIssuedClient,
    };
}

